export default __webpack_public_path__ + "static/media/httpService.c524638b.less";